import { useContext } from "react";
import MemberContext from "../../../context/MemberProvider";
import jwt_decode from "jwt-decode";
import { MemberSidebarData } from "./MemberSidebarData";
import { Link } from "react-router-dom";
import { useQuery } from "react-query";
import { getPortalUserByEmail } from "../../../api/apiServices";

const MemberSidebar = ({ allowedRoles }) => {
	let menuItems = [];
	const { mem } = useContext(MemberContext);
	const email = mem.email;

	const { data: portal_user } = useQuery(["portal_user", email], () =>
		getPortalUserByEmail(email)
	);

	const decoded = mem?.accessToken ? jwt_decode(mem.accessToken) : undefined;

	const role = decoded?.UserInfo?.role || [];

	role === allowedRoles.Member
		? (menuItems = MemberSidebarData)
		: (menuItems = [{}]);

	return (
		<div className="main-sidebar">
			<section className="sidebar show-sidebar">
				<div className="profile-container">
					<img
						src={`/images/members/${portal_user?.profile_picture}`}
						className="image"
						alt=""
					/>
					<h3 className="name">
						{portal_user?.first_name} {portal_user?.last_name}
					</h3>
					<p className="role">
						<strong>{portal_user?.pf_number}</strong>
					</p>
				</div>

				<ul className="sidebar-menu">
					{menuItems?.map((item, index) =>
						!item.subNav ? (
							<li className="treeview" key={index}>
								<Link to={item.path}>
									<span>{item.title}</span>
								</Link>
							</li>
						) : (
							<li className="treeview" key={index}>
								<Link item={item.path}>
									<span>{item.title}</span>
									<span className="pull-right-container">
										<i className="fa fa-plus pull-right"></i>
									</span>
								</Link>
								<ul className="treeview-menu">
									{item.subNav.map((item, index) =>
										!item.subNav ? (
											<li
												className="treeview"
												key={index}
											>
												<Link to={item.path}>
													<i className="fa fa-minus"></i>
													<span>{item.title}</span>
												</Link>
											</li>
										) : (
											<li
												className="treeview"
												key={index}
											>
												<Link item={item.path}>
													<i className="fa fa-minus"></i>
													<span>{item.title}</span>
													<span className="pull-right-container">
														<i className="fa fa-plus pull-right"></i>
													</span>
												</Link>
												<ul className="treeview-menu">
													{item.subNav.map(
														(item, index) => (
															<li
																className="treeview"
																key={index}
															>
																<Link
																	to={
																		item.path
																	}
																>
																	<i className="fa fa-minus"></i>
																	{item.title}
																</Link>
															</li>
														)
													)}
												</ul>
											</li>
										)
									)}
								</ul>
							</li>
						)
					)}
				</ul>
            </section>
            
			<section className="sidebar hide-sidebar">
				<div className="profile-container">
					<img
						src={`/images/members/${portal_user?.profile_picture}`}
						className="image"
						alt=""
					/>
					<h3 className="name">
						{portal_user?.first_name} {portal_user?.last_name}
					</h3>
					<p className="role">
						<strong>{portal_user?.pf_number}</strong>
					</p>
				</div>

				<ul className="sidebar-menu">
					{menuItems?.map((item, index) =>
						!item.subNav ? (
							<li className="treeview" key={index}>
								<Link
									to={item.path}
									className="sidebar-toggle"
									data-toggle="offcanvas"
								>
									<span>{item.title}</span>
								</Link>
							</li>
						) : (
							<li className="treeview" key={index}>
								<Link item={item.path}>
									<span>{item.title}</span>
									<span className="pull-right-container">
										<i className="fa fa-plus pull-right"></i>
									</span>
								</Link>
								<ul className="treeview-menu">
									{item.subNav.map((item, index) =>
										!item.subNav ? (
											<li
												className="treeview"
												key={index}
											>
												<Link
													to={item.path}
													className="sidebar-toggle"
													data-toggle="offcanvas"
												>
													<i className="fa fa-minus"></i>
													<span>{item.title}</span>
												</Link>
											</li>
										) : (
											<li
												className="treeview"
												key={index}
											>
												<Link item={item.path}>
													<i className="fa fa-minus"></i>
													<span>{item.title}</span>
													<span className="pull-right-container">
														<i className="fa fa-plus pull-right"></i>
													</span>
												</Link>
												<ul className="treeview-menu">
													{item.subNav.map(
														(item, index) => (
															<li
																className="treeview"
																key={index}
															>
																<Link
																	className="sidebar-toggle"
																	data-toggle="offcanvas"
																	to={
																		item.path
																	}
																>
																	<i className="fa fa-minus"></i>
																	{item.title}
																</Link>
															</li>
														)
													)}
												</ul>
											</li>
										)
									)}
								</ul>
							</li>
						)
					)}
				</ul>
			</section>
		</div>
	);
};

export default MemberSidebar;
